import { render } from "./PrimaNota.vue?vue&type=template&id=53aebb45&scoped=true"
import script from "./PrimaNota.vue?vue&type=script&lang=js"
export * from "./PrimaNota.vue?vue&type=script&lang=js"

import "./PrimaNota.vue?vue&type=style&index=0&id=53aebb45&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53aebb45"]])

export default __exports__